import { Link } from "react-router-dom";
import { ArrowLeft, Check, Mail, Phone, Building2 } from "lucide-react";
import { PRIVACY_DATA } from "../data/privacyData";

const Section = ({ children }) => (
  <div className="mb-10">{children}</div>
);

export default function PrivacyPage() {
  return (
    <>
      {/* Hero */}
      <section className="bg-[#2C2A2B] pt-32 pb-16 lg:pt-40 lg:pb-20">
        <div className="max-w-4xl mx-auto px-6">
          <div className="flex items-center justify-between mb-8">
            <Link to="/" className="inline-flex items-center gap-2 text-sm text-white/40 hover:text-[#E5BD77] transition-colors">
              <ArrowLeft className="w-4 h-4" /> Back to Home
            </Link>
            <div className="inline-flex items-center gap-2 bg-[#308795]/20 text-[#80d4df] text-sm font-semibold px-4 py-1.5 rounded-full">
              <span className="w-2 h-2 bg-[#308795] rounded-full" />
              Legal
            </div>
          </div>
          <h1 className="text-4xl sm:text-5xl font-bold text-white leading-tight mb-3">Privacy Notice</h1>
          <p className="text-sm text-[#A9B294]">Last Updated: {PRIVACY_DATA.lastUpdated}</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 lg:py-24 bg-[#FAFAF7]">
        <div className="max-w-4xl mx-auto px-6">
          {/* Intro */}
          <p className="text-base text-[#494546] leading-relaxed mb-12">{PRIVACY_DATA.intro}</p>

          {/* Sections */}
          {PRIVACY_DATA.sections.map((sec, i) => (
            <Section key={i}>
              <h2 className="text-2xl font-bold text-[#2C2A2B] mb-4 pb-2 border-b border-[#E0D1BB]/40">{sec.title}</h2>

              {sec.paragraphs && sec.paragraphs.map((p, j) => (
                <p key={j} className="text-sm text-[#6B6567] leading-relaxed mb-4">{p}</p>
              ))}

              {sec.bullets && (
                <ul className="space-y-2 mb-4">
                  {sec.bullets.map((b, j) => (
                    <li key={j} className="flex items-start gap-3">
                      <Check className="w-4 h-4 text-[#308795] mt-0.5 shrink-0" />
                      <span className="text-sm text-[#494546]">{b}</span>
                    </li>
                  ))}
                </ul>
              )}

              {sec.subsections && sec.subsections.map((sub, j) => (
                <div key={j} className="mb-5">
                  <h3 className="text-sm font-bold text-[#308795] uppercase tracking-wider mb-2">{sub.heading}</h3>
                  <ul className="space-y-1.5 pl-1">
                    {sub.items.map((item, k) => (
                      <li key={k} className="flex items-start gap-3">
                        <Check className="w-3.5 h-3.5 text-[#7EA13E] mt-0.5 shrink-0" />
                        <span className="text-sm text-[#494546]">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}

              {sec.contact && (
                <div className="bg-white border border-[#E0D1BB]/30 rounded-xl p-6 mt-4">
                  <div className="flex items-center gap-3 mb-3">
                    <Building2 className="w-5 h-5 text-[#308795]" />
                    <span className="text-sm font-bold text-[#2C2A2B]">{sec.contact.company}</span>
                  </div>
                  <div className="space-y-2">
                    <div className="flex items-center gap-3">
                      <Phone className="w-4 h-4 text-[#8A8385]" />
                      <a href={`tel:${sec.contact.tel}`} className="text-sm text-[#308795] hover:underline">{sec.contact.tel}</a>
                    </div>
                    <div className="flex items-center gap-3">
                      <Mail className="w-4 h-4 text-[#8A8385]" />
                      <a href={`mailto:${sec.contact.email}`} className="text-sm text-[#308795] hover:underline">{sec.contact.email}</a>
                    </div>
                  </div>
                </div>
              )}

              {sec.closing && (
                <p className="text-sm text-[#6B6567] leading-relaxed mt-4 italic">{sec.closing}</p>
              )}
            </Section>
          ))}
        </div>
      </section>
    </>
  );
}
